import {
  footerBaseStyle,
  TFooterTheme,
} from '../../base/customComponents/footer';
import { TStyleConfig } from '../../base/types';

export const Footer: TStyleConfig<TFooterTheme> = {
  baseStyle: {
    ...footerBaseStyle,
    footer: {
      ...footerBaseStyle.footer,
      pb: '0',
      bg: 'transparent',
      bgSize: 'cover',
      bgPos: 'bottom',
      py: '0',
      color: 'white',
    },
    stackGap: '1',
    footerBar: {
      display: 'flex',
      flexDir: ['column', null, 'row'],
      pr: ['0', null, '3'],
      mb: '8',
      borderRadius: 'md',
      alignItems: 'center',
      justifyContent: ['center', null, 'unset'],
      '& > img': {
        maxW: '250px',
        ml: '-1',
      },
    },
    footerLink: {
      color: 'beta.400',
      textTransform: 'lowercase',
      cursor: 'pointer',
      display: 'inline-block',
      mt: '0',
      whiteSpace: 'nowrap',
      fontWeight: 'bold',
    },
    footerLinkTel: {
      color: 'beta.400',
      textTransform: 'lowercase',
      cursor: 'pointer',
      display: 'inline-block',
      mt: '0',
      whiteSpace: 'nowrap',
      fontWeight: 'bold',
    },
    customFooterLink: {
      color: 'beta.400',
      textTransform: 'capitalize',
      cursor: 'pointer',
      display: 'inline-block',
      mt: '0',
      whiteSpace: 'nowrap',
      fontWeight: 'bold',
      fontSize: 'base',
    },
    footerLinks: {
      ml: ['unset', null, 'auto'],
      pb: ['4', null, '0'],
      alignItems: 'center',
      justifyContent: ['space-around', null, 'unset'],
      color: 'beta.400',
      fontWeight: 'medium',
      flexDir: ['row', null, 'unset'],
      display: 'inline-flex',
      mt: ['3', null],
    },
    footerContentContainer: {
      px: ['2.5', 'unset'],
      gap: '6',
      ...footerBaseStyle.footerContentContainer,
      bg: [null, null, 'transparent'],
      justifyContent: 'space-between',
      '&': {
        flexDirection: ['column', null, 'column'],
      },
    },
    footerDownloadImage: {
      borderRadius: 'md',
      border: '2px solid white',
    },
    nav: {
      ...footerBaseStyle.nav,
      minW: [null, null, '370px'],
      mt: ['0', 'unset'],
      display: ['flex', 'grid'],
      gridTemplateColumns: '1fr 1fr 1fr',
      gridTemplateRows: 'auto',
      columnGap: '28',
      rowGap: '0',
      alignItems: ['center', 'end'],
      gridTemplateAreas: `
        ". ."
      `,

      '> a': {
        color: 'white',
      },
    },
    blurb: {
      ...footerBaseStyle.blurb,
      flex: 'unset',
      textAlign: 'left',
      color: 'beta.200',
      width: 'unset',
      mb: '0',
      ml: [null, '0'],
      mr: [null, null, '4'],
    },
    blurbHeading: {
      ml: 'unset',
      mt: 'unset',
      color: 'white',
    },
    blurbHeadingAge: {
      ...footerBaseStyle.blurbHeadingAge,
      color: 'white',
      border: '4px',
      mb: '2',
      boxSize: '8',
      fontSize: 'xs',
      lineHeight: 'normal',
    },
    blurbHeadingThink: {
      fontSize: 'xs',
      color: 'white',
      fontWeight: 'bold',
      mb: '4',
    },
    blurbContent: {
      ...footerBaseStyle.blurbContent,
      ml: 'unset',
      mr: [null, null, 'auto'],
      color: 'white',
      fontSize: 'sm',
    },
    copyright: {
      ...footerBaseStyle.copyright,
      color: 'white',
      textAlign: ['center', 'left'],
      mt: ['7'],
      px: ['8', 'unset'],
      py: '0',
      fontWeight: ['semibold', 'medium'],
    },
    copyrightContainer: {
      color: 'beta.200',
    },
    container: {
      bg: 'transparent',
      borderRadius: ['0', '0', '8'],
      mt: '3',
      '&&': {
        px: '0',
      },
    },
    emailUs: {
      fontSize: 'sm',
      fontWeight: 'bold',
      color: 'white',
    },
    quickLinks: {
      color: ['beta.400', 'white'],
      textTransform: ['uppercase', 'none'],
      textAlign: ['center', 'left'],
      fontSize: ['xs', 'md'],
    },
    ourPartners: {
      fontSize: ['xs', 'md'],
      color: ['beta.400', 'white'],
      textTransform: ['uppercase', 'none'],
    },
    weAccept: {
      fontSize: ['xs', 'md'],
      color: ['beta.400', 'white'],
      textTransform: ['uppercase', 'none'],
    },
    partnerWrapper: {
      mr: 'unset',
    },
  },
  sizes: {},
  variants: {},
};
